import equal from 'deep-equal'
import { atom } from 'jotai'

import { brandGroupIdAtom } from '~/atoms'
import { exists } from '~/utils'

import { lastTabulationParamsAtom } from './queryAtoms'
import {
  brandIdsAtom,
  importanceQuestionIdAtom,
  liftSaQuestionIdAtom,
  npiDriverQuestionIdAtom,
} from './stateAtoms'

export const isTabulatableAtom = atom((get) => {
  const npi = get(npiDriverQuestionIdAtom)
  const imp = get(importanceQuestionIdAtom)
  const lift = get(liftSaQuestionIdAtom)

  return (
    exists(get(brandGroupIdAtom)) &&
    0 < get(brandIdsAtom).length &&
    exists(npi) &&
    exists(imp) &&
    exists(lift) &&
    npi !== imp &&
    npi !== lift &&
    imp !== lift
  )
})

// ブランド / 設問の差分のみを「ボタン押下待ち」状態として扱う。
// 絞り込み（surveyFilter）変更は useTabulationQuery 側で自動再集計するため除外。
export const isPendingTabulationAtom = atom((get) => {
  const last = get(lastTabulationParamsAtom)
  if (last === null) {
    return true
  }

  const current = {
    brandGroupId: get(brandGroupIdAtom),
    brandIds: get(brandIdsAtom),
    npiDriverQuestionId: get(npiDriverQuestionIdAtom),
    importanceQuestionId: get(importanceQuestionIdAtom),
    liftSaQuestionId: get(liftSaQuestionIdAtom),
  }

  const lastCompare = {
    brandGroupId: last.brandGroupId,
    brandIds: last.brandIds,
    npiDriverQuestionId: last.npiDriverQuestionId,
    importanceQuestionId: last.importanceQuestionId,
    liftSaQuestionId: last.liftSaQuestionId,
  }

  return !equal(lastCompare, current)
})
